<div >
    <div class="name-title d-flex align-items-center justify-content-between">
        <h4>{{'MYACCOUNT.ActivityLog' | translate}}</h4>
        <div class="search-form-wrapper">
            <div class="search-form">
              <input type="text" #searchText (keyup)="searching()" placeholder="{{'Search' | translate}}..." >
            </div>
        </div>
    </div>
    <hr>
    <div class="activity-log">
      <ng-container *ngIf ="(activityLogList | search : searchText.value) as result">
        <table mat-table [dataSource]="result" style="width: 100%;">
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef> {{'MYACCOUNT.Title' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.supplierActivity | translate }} </td>
            </ng-container>
          
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef> {{'MYACCOUNT.Date' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.supplierLogDate | date : 'dd/MM/yyyy HH:mm'}} </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="activityLogListDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: activityLogListDisplayedColumns;"></tr>
          </table>
          <div *ngIf="result.length == 0" class="no-record-found">{{'No_record_found' | translate}}</div>
      </ng-container>
    </div>
</div>

